import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollapsedChipSingleSelect',
    props: {
        modelValue: {},
        options: {},
        size: { default: "medium" }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const select = (value) => {
            emit("update:modelValue", value);
        };
        const sizeClass = computed(() => {
            return props.size === "small" ? "chip-group--small" : "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", {
                class: _normalizeClass(["chip-group chip-group--collapsed", sizeClass.value])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: option.value,
                        class: _normalizeClass({ active: _ctx.modelValue === option.value }),
                        onClick: ($event) => (select(option.value))
                    }, _toDisplayString(option.displayName), 11 /* TEXT, CLASS, PROPS */, _hoisted_1));
                }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */));
        };
    }
});
